module.exports = __webpack_public_path__ + "assets/97b7f144cd30764b0f784d83281e9b94.png";